import { View } from "@/components/ui/view";
import React, { useState, useEffect } from 'react';
import { FlatList } from "react-native-gesture-handler";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSelector, useDispatch } from "react-redux";
import Footer from "@/components/basic/Footer";
import WorkflowListElement from '@/components/workflow/WorkflowListElement';
import { switchScreen } from '@/hooks/navigate';
import { backendRequest } from '@/stores/thunks';
import i18n from 'i18n-js';
import Moment from 'moment';

export default function DeletedWorkflows({ navigation }) {

    const insets = useSafeAreaInsets();
    const server = useSelector((state) => state.server)
    const deleted = useSelector((state) => state.deleted)
    const dispatch = useDispatch()

    const [selected, setSelected] = useState([])

    const data = deleted

    useEffect(() => {
        navigation.setOptions({ info: i18n.t(server.online ? 'deletedWorkflows.online' : 'deletedWorkflows.offline') })
        dispatch(backendRequest('GET_CONTACTS_INLINE', '/contact/user', null, 'GET', false))
    }, [])

    const deleteSelected = () => {
        console.log(selected)
        if (selected.length > 0) {
            dispatch(backendRequest('DELETE_TASKS_INLINE', '/workflow/delete', {
                workflows: deleted.filter(task => selected.includes(task.id)).map(task => task.workflowId)
            }, 'DELETE', false))
        }
        switchScreen(navigation, 'BACK')
    }

    const unDeleteSelected = () => {
        console.log(selected)
        if (selected.length > 0) {
            dispatch(backendRequest('UNDELETE_TASKS_INLINE', '/workflow/undelete', {
                workflows: deleted.filter(task => selected.includes(task.id)).map(task => task.workflowId)
            }, 'PUT', false))
        }
        switchScreen(navigation, 'BACK')
    }

    const onPress = (taskid) => {
    }

    const renderItem = ({ item, index }) => {
        return <WorkflowListElement navigation={navigation} taskid={item.id} showProgress={false} showTimer={false} onPress={onPress} selected={selected.includes(item.id)} onSelect={server.online ? onSelect : null} info={i18n.t('deletedWorkflows.info', {days: 10 + Moment(item.deleted).diff(Moment(), 'days')})} />
    }

    const onSelect = (taskid, isSelected) => {
        if (isSelected) {
            setSelected(prev => {
                const next = [...prev]
                next.push(taskid)
                return next
            })
        } else {
            setSelected(prev => {
                const next = prev.filter(id => id != taskid)
                return next
            })
        }
    }

    return (
        <View className="bg-secondary-50 flex-1">
            <FlatList className="bg-secondary-50"
                contentContainerStyle={{ paddingBottom: 120 + insets.bottom }}
                data={data}
                renderItem={renderItem}
                keyExtractor={item => item?.id}
            />
            <Footer navigation={navigation}
                button={server.online ? { action: deleteSelected, info: 'deletedWorkflows.button', color: 'bg-ina-red', disabled: selected.length == 0 } : null}
                button2={server.online ? { action: unDeleteSelected, info: 'deletedWorkflows.button2', disabled: selected.length == 0 } : null}
            />
        </View>
    );
}